import { tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { Box } from '../layout';

export const FormWrapper = styled.div`
  max-width: 700px;
  width: 100%;
  text-align: center;
  background: ${({ theme }) => theme.backgroundLightest};
  margin-top: 20px;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.backgroundLighter};
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;

  & > * + * {
    margin-top: 20px;
  }
  & > :first-child {
    margin-top: 0;
  }
`;

export const Sent = styled(Box)`
  margin: 80px auto;
  @media screen and (${tabletMax}) {
    margin: 40px 0;
  }
`;
